<template>
  <component class="Btn-Social" :is="get_tagName" :href="get_linkAttr" :disabled="disabled">
    <div class="Btn-Social__icon">
      <GoogleIcon v-if="get_isGoogle"/>
      <TelegramIcon v-else-if="get_isTelegram"/>
    </div>
    {{ get_btnText }}
  </component>
</template>

<script setup>
  import { Props } from './scripts/props.js';
  import { defineProps, computed } from 'vue';
  //--------------------------
  import GoogleIcon from '@shared/UI/SVG/GoogleIcon.vue';
  import TelegramIcon from '@shared/UI/SVG/TelegramIcon.vue';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  //Определяем тип тега (button или a)
  const get_tagName = computed(() => props.link ? 'a' : 'button');
  //Определяем ссылку
  const get_linkAttr = computed(() => props.link ? props.link : null);
  //Отобразить гугл иконку?
  const get_isGoogle = computed(() => props.type === 'google');
  //Отобразить телеграм иконку?
  const get_isTelegram = computed(() => props.type === 'telegram');
  //Отображаем текст кнопки в зависиости от выбранного типа иконки или указанного текста
  const get_btnText = computed(() => {
    if(props.text) return props.text;
    switch(props.type){
      case 'google':   return 'Google';
      case 'telegram': return 'Telegram';
      default:         return 'No Text';
    }
  })
</script>

<style lang="scss">
  @import './styles/_conf';
</style>